
export const getBuyerName = () => {
    const domainName = window.location.hostname;
    
    // Check for brand=OA in URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    // const allowedBrands = ['OA', 'Harrington'];
    const allowedBrands = ['cw9gq0iPKPJnyzNQYD143w', 'ryE8ynR9joQQ3uj4eybFUg'];
    const b_id = allowedBrands.includes(urlParams.get('b_id')) ? urlParams.get('b_id') : '';
    if (b_id && b_id.trim() !== '') {
       const brandName = (b_id == 'cw9gq0iPKPJnyzNQYD143w') ? 'OA' : (b_id == 'ryE8ynR9joQQ3uj4eybFUg') ? 'Harrington' : '';
        localStorage.setItem('brand', brandName);
        localStorage.setItem('b_id', b_id);
        return {brand : brandName, b_id: b_id};
    }
    // First determine the default buyer based on domain
    let defaultBuyer;
    if ( domainName.includes('lookupfinance.co.uk') || domainName.includes('scanandclaim.co.uk') || domainName.includes('savvyfinances.co.uk' || domainName.includes('myreclaim.co.uk'))) {
        defaultBuyer = 'OA';
    }else if(domainName === 'localhost' ||domainName.includes('optimus-claims.co.uk') || domainName.includes('direct-refunds.co.uk') || domainName.includes('onlinefinanceclaims.co.uk')){
        defaultBuyer = 'Harrington';
    } else {
        defaultBuyer = 'OA';
    }
    const brandValue = (defaultBuyer === 'OA') ? 'cw9gq0iPKPJnyzNQYD143w' : 'ryE8ynR9joQQ3uj4eybFUg';
    localStorage.setItem('brand', defaultBuyer);
    localStorage.setItem('b_id', brandValue);
    return {brand: defaultBuyer, b_id: brandValue};
  };
  

export const getKeyFromOaPercentage = (oaPercentage) => {
    const allowedBrands = ['OA', 'Harrington'];
    const brandName = allowedBrands.includes(oaPercentage) ? oaPercentage : allowedBrands.includes(localStorage.getItem('oaPercentage')) ? localStorage.getItem('oaPercentage') : '';
    if (brandName && brandName.trim() !== '') {
        const oaKey = (brandName === 'OA') ? 'cw9gq0iPKPJnyzNQYD143w' : (brandName === 'Harrington') ? 'ryE8ynR9joQQ3uj4eybFUg' : '';
        return oaKey;
    }
    return '';
}

export const getOaPercentageFromKey = (key) => {
    const allowedBrands = ['cw9gq0iPKPJnyzNQYD143w', 'ryE8ynR9joQQ3uj4eybFUg'];
    const brandName = allowedBrands.includes(key) ? (key === 'cw9gq0iPKPJnyzNQYD143w') ? 'OA' : (key === 'ryE8ynR9joQQ3uj4eybFUg') ? 'Harrington' : '' : '';
    return brandName;
}